<template>
  <div class="warp_3d">
    <div class="warp_content">
      <div class="searchArear">
        <el-select clearable class="select_category" v-model="value" @change="fenleiChoose" placeholder="请选择商品分类">
          <el-option v-for="(item, index) in categoryOptions" :key="index" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
        <el-select clearable class="select_category" v-model="saleArr" @change="saleArrChoose" placeholder="请选择商品分类">
          <el-option v-for="(item, index) in saleArrList" :key="index" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <search :inputAndSelectShow="true" :placeholder1="placeholder1" :placeholder2="placeholder2" :options="options"
          @changeValue="changeValue" @searchBtn="searchBtn"></search>
      </div>
      <div class="allBtn">
        <el-button plain @click="addGoods">录入商品</el-button>
        <el-button plain @click="sj_click">上架</el-button>
        <el-button plain @click="dowm_click">下架</el-button>
        <el-button plain @click="shezhijingxuan">设为精选</el-button>
        <el-button plain @click="canceljingxuan">取消精选</el-button>
        <el-button plain @click="dialogVisible = true" :disabled="!rowMessage.length">批量设置分销</el-button>
        <el-button plain @click="eitorClick(paiXuEitor)">{{ paiXuEitor ? '排序编辑' : '保存编辑' }}</el-button>
        <!-- <el-button plain @click="clickTo">保存编辑</el-button> -->
      </div>
      <dataTable ref="dataTable" :flush="fresh" :inSerachFilte="inSerachFilte" :inTableData="tableDataConfig"
        :inAjax="tableAjaxConfig" :ispagination="true" @rowClick="tableClickConfig" @selection="selection"
        @paixuList="paixuList"></dataTable>

      <vdialog ref="vdialog" :title="sjDialog_title" :message="sjDialog_message" :titleMessage="titleMessage"
        @isOk="sure_sj"></vdialog>

      <detailDioalog ref="detailDialog"></detailDioalog>

    </div>
    <el-dialog title="分销设置" :visible.sync="dialogVisible" :modal-append-to-body="false" width="900px">
      <div class="unify">
        <div class="charte_title">统一设置</div>
        <div>(统一设置选中的商品的分销比例)</div>
      </div>
      <el-row>
        <el-col :span="24" class="charte">
          <div class="charte_type">
            <div>是否开启分销</div>
            <el-switch class="padding" v-model="unifyChart.offDistribution">
            </el-switch>
          </div>
          <el-radio-group v-model="unifyChart.distributionType" v-show="unifyChart.offDistribution">
            <el-radio :label="1">百分比</el-radio>
            <el-radio :label="2">固定金额</el-radio>
          </el-radio-group>
          <div class="charte_type" v-show="unifyChart.offDistribution">
            <div>分销比例</div>
            <el-input v-model="unifyChart.distribution" placeholder="请输入内容"></el-input>
            <span v-if="unifyChart.distributionType == '2'" style="color: red; margin-left: 20px;">元</span>
            <span v-if="unifyChart.distributionType == '1'" style="color: red; margin-left: 20px;">%</span>
          </div>
        </el-col>
      </el-row>
      <div class="unify">
        <div class="charte_title">单个设置</div>
        <div>(单个设置选中的商品的分销比例)</div>
      </div>
      <el-row v-for="(item, index) in rowMessage" :key="index">
        <el-col :span="24" class="charte">
          <img :src="getImageUrl(item)" style="width: 50px; height: 50px;" />
          <span>{{ item.name }}</span>
          <div class="charte_type">
            <div>是否开启分销</div>
            <el-switch class="padding" v-model="item.offDistribution">
            </el-switch>
          </div>
          <el-radio-group v-model="item.distributionType">
            <el-radio :label="1">百分比</el-radio>
            <el-radio :label="2">固定金额</el-radio>
          </el-radio-group>
          <div class="charte_type">
            <div>分销比例</div>
            <el-input v-model="item.distribution" placeholder="请输入内容"></el-input>
            <span v-if="item.distributionType == '2'" style="color: red; margin-left: 20px;">元</span>
            <span v-if="item.distributionType == '1'" style="color: red; margin-left: 20px;">%</span>
          </div>
        </el-col>
      </el-row>

      <span slot="footer" class="dialog-footer">
        <el-button @click="offDialogVisible">取 消</el-button>
        <el-button type="primary" @click="saveDialogVisible">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import search from "../components/search";
import vdialog from "../components/dialog";
import detailDioalog from "../components/operationDetails";
import GlobalUtil from "@/utils/globalUtil.js";

export default {
  components: {
    vdialog,
    search,
    detailDioalog
  },
  data() {
    return {
      obj: {
        'rankIndex': 1
      },
      saleArr: '',
      rowMessage: [], // 本行数据
      jingXuanSetup: true, // 精选设置
      paiXuEitor: true, // 排序设置
      sjDialog_title: null, // 对话框内容
      sjDialog_message: null,
      titleMessage: null,
      placeholder1: "请选择商品标签",
      placeholder2: "请输入商品编码/商品名称",
      categoryOptions: [], // 下拉框的
      options: [
        {
          value: "",
          label: "全部"
        },
        {
          value: "1",
          label: "精选"
        },
        // {
        //   value: "0",
        //   label: "非精选"
        // }
      ], // 传给搜索组件的
      value: "",
      //用于tableData组件刷新，tableData检测到fresh值发生变化就会刷新数据
      fresh: "",
      // 用于匹配搜索数据，返回新的数据
      inSerachFilte: {},
      //tableData组件参数配置
      tableDataConfig: {
        //表头及字段配置
        tHead: [
          {
            name: "商品图片",
            field: "mainImgs",
            type: "image",
            width: 150,
            height: 150,
            click: true,
            callback: function (v, row) {
              if (v) {
                return JSON.parse(v)[0];
              }
            }
          },
          {
            name: "商品名称",
            field: "name"
          },
          {
            name: "商品类目",
            field: "ctgName",
          },
          {
            name: "商品编码",
            field: "id"
          },
          {
            name: "商品价格",
            field: "custRetail",
            type: 'function',
            callback: function (v, row) {
              return `<span>${v ? '￥' + v + '/' + (row.mmUnitName || '台') : '-'}</span>`
            }
          },
          {
            name: "状态",
            field: "onSale",
            type: "function",
            callback: function (v, row) {
              let obj = {
                0: "未上架",
                1: "已上架",
                2: "已下架"
              };
              return obj[v];
            }
          },
          {
            name: "商品标签",
            field: "label",
            type: "function",
            callback: function (v, row) {
              let obj = {
                1: "<div style='color:#fff;width:42px;height:22px;background:#FF721F;margin:0 auto'>精选</div>"
              };
              return obj[v];
            }
          },
          {
            name: "录入时间",
            field: "createDate"
          },
          {
            name: "排序",
            field: "orderFlag",
            type: "textInput",
            isShow: true
            // type:'input'
          },
          {
            name: "分销开启",
            field: "offDistribution",
            type: "function",
            callback: function (v, row) {
              return v === true ? '开启' : '未开启';
            }
          },
          {
            name: "分销类型",
            field: "distributionType",
            type: "function",
            callback: function (v, row) {
              return v == 1 ? '百分比' : '固定金额';
            }
          },
          {
            name: "分销金额",
            field: "distribution",
            type: "function",
            callback: function (v, row) {
              let distribution = v;
              if (row.distributionType === 1) {
                return (distribution * 100) + '%';
              } else if (row.distributionType === 2) {
                return distribution;
              }
            }
          },
          {
            name: "操作",
            type: "actionBtns", //配置操作按钮actionSelectBtns为下拉按钮，actionBtns为平铺按钮
            field: "sendDate",
            callback: function (v, row) {
              let arr = [
                {
                  type: "edit",
                  label: "<span>编辑</span>"
                },
                {
                  type: "delete",
                  label: "<span>删除</span>",
                  callback: function (row) {
                    return row.onSale === 2 || row.onSale == 0
                  }
                },
                {
                  type: "detail",
                  label: "<span>操作详情</span>"
                }
              ];
              return arr;
            }
          }
        ],
        //自动渲染
        tData: [],
        //自动渲染
        total: 0,
        actionBtWidth: "250",
        //配置是否显示多选框
        isMultiple: true,
        dispatchp: true,
        //配置是否显示排序
        isRank: true
      },
      tableAjaxConfig: {
        url: this.$url.goodsList,
        method: "post",
        data: {
          pageNumber: 1,
          pageSize: 15,
          queryObj: {
            'rankIndex': 1
          }
        }
      },
      saleArrList: [
        {
          label: '全部',
          value: ''
        },
        {
          label: '未上架',
          value: '0'
        },
        {
          label: '已上架',
          value: '1'
        },
        {
          label: '已下架',
          value: '2'
        }
      ],
      dialogVisible: false,
      // 统一分销
      unifyChart: {}
    };
  },
  created() {
    // 类目列表
    this.getCategoryList();
  },
  mounted() {
  },
  watch: {
    unifyChart: {
      handler(newValue, oldValue) {
        if (newValue.distribution != null) {
          this.rowMessage.forEach(item => {
            item.distribution = newValue.distribution;
          });
        }
        if (newValue.distributionType != null) {
          this.rowMessage.forEach(item => {
            item.distributionType = newValue.distributionType;
          });
        }
        if (newValue.offDistribution != null) {
          this.rowMessage.forEach(item => {
            item.offDistribution = newValue.offDistribution;
          });
        }
      },
      deep: true
    }
  },
  methods: {
    // 新增商品
    addGoods() {
      this.$router.push({
        name: "3dshoppinggoodMessagetentryGoods",
        query: { data: "add" }
      });
    },
    // 上架点击事件
    sj_click() {
      if (this.rowMessage && this.rowMessage.length > 0) {
        this.sjDialog_title = "是否上架商品？";
        this.sjDialog_message = "";
        this.titleMessage = "上架";
        this.$refs.vdialog.query('up');
      } else {
        this.$message.warning('请选择商品')
      }
    },
    // 下架点击事件
    dowm_click() {
      if (this.rowMessage && this.rowMessage.length > 0) {
        this.sjDialog_title = "是否下架商品？";
        this.sjDialog_message = "";
        this.titleMessage = "下架";
        this.$refs.vdialog.query('down');
      } else {
        this.$message.warning('请选择商品')
      }
    },
    //确认框返回的函数
    sure_sj(data) {
      if (data === 'up') {
        this.$refs.vdialog.centerDialogVisible = false;
        let ids = this.rowMessage.map(_ => {
          return _.id;
        });
        this.$axios.post(this.$url.modifyOnSale, {
          ids: ids,
          onSale: "1"
        }).then(res => {
          this.rowMessage = null
          this.fresh = new Date();
          console.log("我是上架", res);
          this.$refs.dataTable.getList();
        });
      } else if (data === 'down') {
        let ids = this.rowMessage.map(_ => {
          return _.id;
        });
        this.$axios.post(this.$url.modifyOnSale, {
          onSale: "2",
          ids: ids
        }).then(res => {
          this.rowMessage = null
          this.fresh = new Date();
          this.$refs.dataTable.getList();
          console.log("我是下架", res);
        });
      } else if (data === 'delete') {
        let id = this.rowMessage.id
        this.$axios.post(this.$url.deleteItem, {
          id: id
        }).then(res => {
          console.log('我是删除', res);
          if (res.code === 0) {
            this.rowMessage = null
            this.fresh = new Date();
            this.$message.error("删除成功")
            this.$refs.dataTable.getList();
          }
        })
      }
    },
    // 操作栏事件
    tableClickConfig(data) {
      if (data.type == "edit") {
        this.$router.push({
          name: "3dshoppinggoodMessagetentryGoods"
        });
        GlobalUtil.setSessionStorage("rowData", data.rowData);
      } else if (data.type === "delete") {
        this.sjDialog_title = "是否删除商品？";
        // this.sjDialog_message = "只能删除下架的商品";
        this.titleMessage = "删除";
        this.rowMessage = data.rowData
        // this.$refs.vdialog.centerDialogVisible = true;
        this.$refs.vdialog.query('delete');
      } else if (data.type === "detail") {
        this.$refs.detailDialog.query(data.rowData, 'SPHL')
      }
    },
    // 类目下拉框事件
    fenleiChoose(e) {
      this.obj["cfgIdArr"] = e ? [e] : [];
      this.inSerachFilte = { queryObj: this.obj };
    },
    saleArrChoose(e) {
      this.obj["saleArr"] = e ? [e] : [];
      this.inSerachFilte = { queryObj: this.obj };
    },
    // 多选框选中
    selection(data) {
      let dataCopy = JSON.parse(JSON.stringify(data));
      dataCopy.forEach(item => {
        if (item.updataDistribution == null || item.updataDistribution == false) {
          item.updataDistribution = true;
          console.log(111);
          if (item.distributionType == 1) {
            console.log(222);
            item.distribution = item.distribution * 100;
          }
        }
      });
      this.rowMessage = dataCopy;
    },
    // 排序列表选中
    paixuList(data) {
      this.rowMessage = data;
    },
    // 设置精选
    shezhijingxuan() {
      if (this.rowMessage && this.rowMessage.length > 0) {
        let ids = this.rowMessage.map(_ => {
          return _.id;
        });
        this.$axios
          .post(this.$url.setLabel, {
            ids: ids
          })
          .then(res => {
            console.log("我是设置精选", res);
            if (res.code === 0) {
              this.rowMessage.map(_ => {
                _.label = 1;
              });
              this.$refs.dataTable.getList();
              this.rowMessage = null
            }
          });


      } else {
        this.$message.warning('请选择商品')
      }
    },
    // 取消精选
    canceljingxuan() {
      if (this.rowMessage && this.rowMessage.length > 0) {
        let ids = this.rowMessage.map(_ => {
          return _.id;
        });
        this.$axios
          .post(this.$url.cancelLabel, {
            ids: ids
          })
          .then(res => {
            if (res.code === 0) {
              this.rowMessage.map(_ => {
                _.label = 0;
              });
            }
            this.$refs.dataTable.getList();
            this.rowMessage = null
          });
      } else {
        this.$message.warning('请选择商品')
      }
    },
    // 下拉框事件
    changeValue(e) {
      if (e) {
        this.obj["labelArr"] = [e];
      } else {
        this.obj["labelArr"] = null
      }
      this.inSerachFilte = { queryObj: this.obj };
    },
    // 搜索按钮点击事件
    searchBtn(e) {
      console.log(e);

      // if (e) {
      this.obj["idOrNameLike"] = e;
      this.inSerachFilte = { queryObj: this.obj };
      // } else {
      //   this.$message.error("请输入内容");
      // }
    },
    // 排序编辑
    eitorClick(value) {
      if (value) {
        let data = this.tableDataConfig.tHead.find(_ => {
          return _.field == "orderFlag";
        });
        data.isShow = false;
        this.paiXuEitor = false;
      } else {
        let data = this.tableDataConfig.tHead.find(_ => {
          return _.field == "orderFlag";
        });

        data.isShow = true;
        this.paiXuEitor = true;
        // 调用接口保存排序
        console.log(this.rowMessage)
        let list = this.rowMessage.map(_ => {
          let obj = {
            id: _.rowData.id,
            orderFlag: _.rowData.orderFlag
          };
          return obj;
        });
        this.$axios
          .post(this.$url.editorSort, {
            list: list
          })
          .then(res => {
            console.log("我是编辑排序", res);
            if (res.code == 0) {
              this.$message.success("编辑成功!");
              this.fresh = new Date();
            }
          });
      }
      this.$forceUpdate()
    },
    // 获取商品列表
    goodsList(obj) {
      this.$axios
        .post(this.$url.goodsList, {
          pageNumber: 1,
          pageSize: 10,
          queryObj: obj
        })
        .then(res => {
          console.log("我是商品列表", res);
          if (res.code == 0) {
            this.tableDataConfig.tData = res.data.list.map(_ => {
              _.mainImgs = JSON.parse(_.mainImgs);
              _["mainImg"] = _.mainImgs[0];
              console.log(_);

              return _;
            });
            console.log(this.tableDataConfig.tData);
          }
        });
    },
    // 类目分类
    getCategoryList() {
      this.$axios.post(this.$url.categoryList, {}).then(res => {
        console.log("我是类目分类", res);
        this.categoryOptions = res.data;
      });
    },
    // 批量分销确认
    saveDialogVisible() {
      this.dialogVisible = false
      this.setBatchModifyItem()
    },
    // 批量分销取消
    offDialogVisible() {
      this.dialogVisible = false
      this.getCategoryList();
    },
    // 更改图片展示类型
    getImageUrl(item) {
      return item.mainImgs ? item.mainImgs.match(/"(.*?)"/)[1] : '';
    },
    // 比例计算
    offDistribution(item) {
      if (item.distributionType === 1) {
        return (item.distribution * 100) + '%';
      } else if (item.distributionType === 2) {
        return item.distribution;
      }
    },
    // 批量编辑商品
    setBatchModifyItem() {
      let modifyItemList = this.rowMessage
      modifyItemList.forEach(item => {
        if (item.distributionType == 1) {
          item.distribution = item.distribution / 100;
        }
      })
      this.$axios.post(this.$url.batchModifyItem, {
        modifyItemList: modifyItemList
      }).then(res => {
        this.$message({
          message: '修改成功',
          type: 'success'
        });
        this.fresh = new Date();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.warp_3d {
  width: 100%;
  padding: 30px;
  box-sizing: border-box;
  background: #ffffff;
}

.cxBtn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.allBtn {
  display: flex;
  right: 10px;
  top: 15px;

  ::v-deep .el-button {
    padding: 8px 16px;
  }
}

::v-deep .chaxun {
  width: 340px;
  height: 36px;
}

.searchArear {
  position: relative;
  height: 60px;
  width: 100%;
  display: flex;
  align-items: center;
}

.select_category {
  width: 200px;

  ::v-deep .el-input__inner {
    height: 36px !important;
  }

  margin-right: 20px;
}

.unify {
  display: flex;
  align-items: center;
}

.charte_title {
  font-size: 28px;
  font-weight: 600;
  margin: 10px 0;
  padding-right: 40px;
}

.charte {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .charte_type {
    display: flex;
    align-items: center;
  }
}
</style>
